import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import * as _ from 'lodash';


@Component({
  selector: 'esc-cargo-details',
  templateUrl: './cargo-details.component.html',
  styleUrls: ['./cargo-details.component.scss']
})
export class CargoDetailsComponent implements OnInit {

  readonly ELEMENT_ID_VIEW = "cargo_details_dialog";

  constructor(
    public dialogRef: MatDialogRef<CargoDetailsComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  public displayedColumns: string[] = [
    "condition",
    "count",
    "kindOfParcel",
    "length",
    "width",
    "height"
  ];
  
  public listData = [];

  ngOnInit() {
    this.listData = this.data;
  }

  public getTotalCount(): number {
    return _.sumBy(this.listData, 'count');
  }

}